module.exports = __webpack_public_path__ + "img/audit.73abd913.png";